import {onBlockLoaded} from "@plaudit/frontend-apis";

const onClick = (e: Event) => {
	if (!(e.target instanceof Element)) {
		return;
	}

	const element = e.target.closest<HTMLElement>(".wp-block-msa-request-a-quote-add-to-quote");
	if (!element || element.classList.contains("not-eligible-for-quotes")) {
		return;
	}

	e.preventDefault();
	e.stopPropagation();

	const form = element.closest("form");
	const {productId, quantity} = getProductIdAndQuantityFromForm(element, form);

	let message: string;
	let success: boolean;
	if (productId) {
		const products = JSON.parse(localStorage.getItem("msa/request-a-quote/products") ?? '{}') as Record<string, number>;
		if (Array.isArray(productId)) {
			for (const pid of productId) {
				products[pid] = pid in products ? products[pid] + quantity : quantity;
			}
		} else {
			products[productId] = productId in products ? products[productId] + quantity : quantity;
		}
		localStorage.setItem("msa/request-a-quote/products", JSON.stringify(products));
		document.dispatchEvent(new Event("msa/region-locked-products/quote-update"));
		success = true;
		message = "Added product(s) to quote";
	} else {
		console.error("Encountered an Add to Quote button without a product id");
		success = false;
		message = "Failed to add product(s) to quote";
	}

	const messagesArea = form?.querySelector<HTMLDivElement>(".messages-area");
	if (messagesArea) {
		messagesArea.dispatchEvent(new CustomEvent("msa/plaudit-custom-theme/updated-quote-or-cart", {detail: {success, message}}));
	}
};

function getProductIdAndQuantityFromForm(element: HTMLElement, form?: HTMLFormElement|null) {
	let productId: string|null|undefined|string[];
	let quantity: number;
	if (form) {
		const idElement = form.elements.namedItem("variation_id") ?? form.elements.namedItem("product_id") ?? form.elements.namedItem("add-to-cart");
		if (idElement instanceof RadioNodeList) {
			productId = [...idElement.values()].filter(element => element.checked).map(element => element.value);
		} else if (idElement instanceof HTMLInputElement) {
			productId = idElement.value;
		}
		quantity = parseInt((form.elements.namedItem("quantity") as HTMLInputElement|null|undefined)?.value || '1');
	} else {
		productId = element.getAttribute("data-product-id");
		quantity = parseInt(element.getAttribute("data-quantity") || '1');
	}
	return {productId, quantity};
}

function updateAddToQuoteButtonInForm(element: HTMLElement, form?: HTMLFormElement|null) {
	const {productId} = getProductIdAndQuantityFromForm(element, form);
	if (!productId) {
		element.style.pointerEvents = 'none';
		element.style.opacity = '50%';
	} else {
		if (!Array.isArray(productId)) {
			updateAddToQuoteButonWithQuantity(element, productId);
		}
		element.style.pointerEvents = '';
		element.style.opacity = '';
	}
}
function updateAddToQuoteButonWithQuantity(element: HTMLElement, productId: string) {
	const quantity = (JSON.parse(localStorage.getItem("msa/request-a-quote/products") ?? '{}') as Record<string, number>)[productId] ?? 0;
	element.setAttribute("data-quantity-in-quote", quantity.toString());
	if (quantity !== 0) {
		const target = element.querySelector<HTMLElement>(".show-when-in-quote");
		if (target) {
			target.innerText = target.getAttribute("data-base-text")?.replaceAll("%n", quantity.toString()) ?? "";
		}
	}
}

let firstBlock = true;
onBlockLoaded({
	blockOrClassName: "msa-request-a-quote/add-to-quote",
	onAdd(blockRoot) {
		// blockRoot is the root element of the block (aka the element that has the wp-block-msa-request-a-quote/add-to-quote class on it)
		// You can add any logic that needs to run once per block here
		blockRoot.addEventListener('click', onClick);
		if (firstBlock) {
			document.addEventListener("msa/region-locked-products/region-update", e => {
				if (!(e instanceof CustomEvent && e.detail['onLoad'])) {
					window.location.reload();
				}
			});
			firstBlock = false;
		}
		const form = blockRoot.closest("form");
		updateAddToQuoteButtonInForm(blockRoot, form);
		if (form) {
			new MutationObserver(changes => {
				if (!changes.find(change => change.target instanceof HTMLInputElement && (change.target.name === 'product_id' || change.target.name === 'variation_id'))) {
					return;
				}
				updateAddToQuoteButtonInForm(blockRoot, form);
			}).observe(form, {attributes: true, subtree: true});
		}

		document.addEventListener("msa/region-locked-products/quote-update", () => updateAddToQuoteButtonInForm(blockRoot, form));
	}
	// If you need to add logic that runs once per removal, add onRemove(blockRoot) {} to this object
});
